<template>
  <div class="language">
    <div class="modal language-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="title">{{ $t("choose-language") }}</p>
          <div class="wrapper">
            <div class="columns is-mobile">
              <div class="column" @click="changeLang('th')">
                <flag iso="th" :squared="false" />
                <p>ภาษาไทย</p>
              </div>
              <div class="column" @click="changeLang('en')">
                <flag iso="gb" :squared="false" />
                <p>English</p>
              </div>
              <div class="column" @click="changeLang('ja')">
                <flag iso="jp" :squared="false" />
                <p>日本語</p>
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column" @click="changeLang('zh')">
                <flag iso="cn" :squared="false" />
                <p>汉语</p>
              </div>
              <div class="column" @click="changeLang('my')">
                <flag iso="mm" :squared="false" />
                <p>မြန်မာစာ</p>
              </div>
              <div class="column" @click="changeLang('km')">
                <flag iso="kh" :squared="false" />
                <p>ភាសាខ្មែរ</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";

export default {
  name: "LanguageModal",
  data() {
    return {};
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setLanguage") this.closeModal();
    });
  },
  methods: {
    closeModal() {
      this.inputCode = "";
      this.error = "";
      this.$el.querySelector(".modal").classList.remove("is-active");
      this.geolocationRequestModal();
      this.updateLocation();
    },
    changeLang(language) {
      this.setLang(language, true);
      if (this.$store.getters.isLoggedIn) {
        this.$store.dispatch("setLanguage", language);
      }
      setTimeout(() => this.closeModal(), 700);
      this.geolocationRequestModal();
      this.updateLocation();
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  max-width: 500px;
  /* border-radius: 25px; */
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 12px;
}
/* .wrapper {
  background-color: rgb(245, 245, 245);
} */
.title {
  /* text-align: left; */
  font-size: 1.4em;
  font-weight: 500;
  color: #555;
  margin-top: 6px;
}
.columns {
  /* background-color: whitesmoke;
  border-radius: 5px; */
  font-size: 1.2em;
}
.flag {
  -webkit-filter: drop-shadow(2px 2px 2px #666);
  filter: drop-shadow(2px 2px 2px #666);
}
.flag-icon {
  filter: drop-shadow(1px 1px 3px #777);
  font-size: 2.3em;
  border-radius: 2px;
  margin-bottom: 10px;
}
.column:active {
  transform: scale(0.95);
}
</style>